ReportsChartService.$inject = ['Time', '_'];

function ReportsChartService(Time, _) {
    this.buildGraph = buildGraph;
    this.buildCakeGraph = buildCakeGraph;
    this.extractGraphInfo = extractGraphInfo;
    this.buildStats = buildStats;

    function buildGraph(chartData, datasets_filter, withTotal) {
        var datasets = _.chain(chartData.datasets).pick(datasets_filter).values().value();

        if (withTotal) {
            var total_dataset = initDataset('Total', '51, 122, 183', chartData.labels.length);
            total_dataset.data = _.map(total_dataset.data, function(value, index) {
                var total = 0;
                _.each(datasets, function(dataset) {
                    total += dataset.data[index];
                });
                return total;
            })
            datasets.push(total_dataset);
        }

        return {
            labels: chartData.labels,
            datasets: datasets
        };
    }

    function buildCakeGraph(chartData, datasets_filter) {
        var datasets = _.chain(chartData.datasets).pick(datasets_filter).values().value();

        var labels = [],
            data = [],
            colors = [];

        _.each(datasets, function(dataset) {
            labels.push(dataset.label);
            data.push(_.sum(dataset.data));
            colors.push(dataset.borderColor);
        });

        return {
            labels: labels,
            datasets: [{
                data: data,
                backgroundColor: colors,
                label: 'Dataset 1'
            }]
        };
    }

    function buildStats(chartData, chart_views) {
        var totals = chartData.totals,
            success_totals = _(totals).pick(chart_views.success).values().sum(),
            cancelled_totals = _(totals).pick(chart_views.cancelled).values().sum(),
            offline_fixed_success = _(totals).pick(['offline', 'fixed']).values().sum(),
            sum_success = totals.online + offline_fixed_success,
            sum_totals = success_totals + cancelled_totals;

        return {
            rate_cancelled: sum_totals <= 0 ? 0 : (cancelled_totals / sum_totals),
            rate_online: sum_success <= 0 ? 0 : (totals.online / sum_success),
            earned: totals.earned
        };
    }

    function extractGraphInfo(results, start, end) {
        var range = Time.rangeToArray({
            start: start,
            end: end
        }, true);

        var range_strings = _.map(range, function(date) {
            return date.format('YYYY-MM-DD');
        });

        var labels = _.map(range, function(date) {
            return date.format('DD MMM');
        });

        var datasets = initGraph(labels.length);
        var totals = _.zipObject(_.keys(datasets), _.fill(Array(_.keys(datasets).length), 0));

        _.each(results, function(day) {
            var index = _.indexOf(range_strings, day.date);

            if (!day.stats) {
                return;
            }

            // Extract every result
            // Online
            datasets.online.data[index] = day.stats.online.count;
            totals.online += day.stats.online.count;
            // Online Cancelled
            datasets.online_cancelled.data[index] = day.stats.online_cancelled.count;
            totals.online_cancelled += day.stats.online_cancelled.count;
            // Online Reported
            datasets.online_reported.data[index] = day.stats.online_reported.count;
            totals.online_reported += day.stats.online_reported.count;
            // Offline
            datasets.offline.data[index] = day.stats.offline.count;
            totals.offline += day.stats.offline.count;
            // Offline cancelled
            datasets.offline_cancelled.data[index] = day.stats.offline_cancelled.count;
            totals.offline_cancelled += day.stats.offline_cancelled.count;
            // Fixed
            datasets.fixed.data[index] = day.stats.fixed.count;
            totals.fixed += day.stats.fixed.count;
            // Fixed cancelled
            datasets.fixed_cancelled.data[index] = day.stats.fixed_cancelled.count;
            totals.fixed_cancelled += day.stats.fixed_cancelled.count;
            // Earnew
            datasets.earned.data[index] = day.stats.earned;
            totals.earned += day.stats.earned;

        });

        return {
            labels: labels,
            datasets: datasets,
            totals: totals
        };
    }

    function initGraph(length) {
        return {
            online: initDataset('Online', '0,161,75', length),
            online_cancelled: initDataset('Online Cancelados', '0,161,75', length),
            online_reported: initDataset('Online Reportados', '130,12,0', length),
            offline: initDataset('Únicos', '105,240,174', length),
            offline_cancelled: initDataset('Únicos Cancelados', '105,240,174', length),
            fixed: initDataset('Fijos', '88,89,91', length),
            fixed_cancelled: initDataset('Fijos Cancelados', '88,89,91', length),
            earned: initDataset('Ganancia Total', '40, 168, 0', length)
        };
    }

    function initDataset(label, rgba, length) {
        return {
            label: label,
            borderColor: 'rgba(' + rgba + ',1)',
            backgroundColor: 'rgba(' + rgba + ',0.9)',
            fill: false,
            data: _.fill(Array(length), 0)
        };
    }
}

export default ReportsChartService;